export function isValidUrl(value: string): boolean {
  try {
    const url = new URL(value);
    const validProtocol = url.protocol === "http:" || url.protocol === "https:";
    const validHostname = url.hostname.includes(".") || url.hostname === "localhost";
    return validProtocol && validHostname;
  } catch {
    return false;
  }
}

export function normalizeUrlForComparison(url: string): string {
  try {
    const u = new URL(url);
    return `${u.protocol}//${u.hostname.toLowerCase()}${u.pathname.replace(/\/$/, "")}${u.search}${u.hash}`;
  } catch {
    return url.toLowerCase().trim();
  }
}
